<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb"><!-- new -->
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Test Configurations</a></li>
          <li><a>Quality Parameters</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <div class="block">
        <div class="page-header"> <!--changed new-->
          <span class="page-header__title">Quality Parameters</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>
        <div class="list_block">
          <div class="toolbar"> <!--search and new changed new-->
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by Quality parameter name"/>
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon"/>
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <!--query params block-->
        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let queryparam of queryParamsList; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg">
                  <span>{{ queryparam && queryparam.name }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <img src="../../../../../../assets/images/New_Icons/calendar-icon.svg">
                  <span>Updated At: {{queryparam && queryparam.updatedAt | date: "dd MMM yyyy"}}</span>
                </div>
                <div class="master-card-body-info">
                  <img src="../../../../../../assets/images/New_Icons/descriptio-card-icon.svg">
                  <span class="description">{{queryparam && queryparam.description ? queryparam && queryparam.description : 'NA'}}</span>
                </div>
                <div class="master-card-body-info">
                  <span>Units of Measurement:</span>
                  <span class="description">{{queryparam && queryparam.uom ? queryparam && queryparam.uom : 'NA'}}</span>
                </div>
                <div class="master-card-body-info">
                  <span>Unit Code:</span>
                  <span class="description">{{queryparam && queryparam.unit_code ? queryparam && queryparam.unit_code : 'NA'}}</span>
                </div>
                <div class="master-card-body-info">
                  <span>Is Derived:</span>
                  <span class="description">{{queryparam && queryparam.is_derived ? queryparam && queryparam.is_derived : 'NA'}}</span>
                </div>
                <div class="master-card-body-info">
                  <span>Quality Parameter Type:</span>
                  <span class="description">{{(queryparam && queryparam.qpType?.name) ? queryparam && queryparam.qpType?.name : 'NA'}}</span>
                </div>
                <div class="master-card-body-info">
                  <span>Test Category:</span>
                  <span class="description">{{(queryparam && queryparam.testCategory?.name) ? queryparam && queryparam.testCategory?.name : 'NA'}}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                  <span class="label">Abbreviation:</span>
                  <span class="text">{{ queryparam?.abbreviation || "NA" }}</span>
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" title="Edit Business Type" (click)="getQueryParamsById(queryparam.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Query Params Not Found</div>
      </div>
      <!--query params block end-->
    </div>
    <!--add/update form-->
    <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
      <!--<div *ngIf="formFieldCount > 7" class="overlay-background" (click)="closeForm()"></div>-->
      <!--outside close-->
      <div class="popup-wrapper">
        <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
        <!-- Actual Popup -->
        <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
          <form [formGroup]="registerForm" novalidate>
            <div class="form-header">
              <div class="form-title">Quality Parameter</div>
              <button class="add-update-submit-button" (click)="addUpdateQueryParams()" [disabled]="queryParamsDoubleClick">
                <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg"></span>
                <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
              </button>
            </div>
            <div class="form-container grid-three-cols">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Quality Parameter</mat-label>
                <input matInput id="activityName" type="text" formControlName="name" autocomplete="off" placeholder="Quality Parameter"/>
                <!-- Hint -->
                <mat-hint><i>3–20 alphabetic characters</i></mat-hint>
                <!-- Single dynamic error -->
                <mat-error *ngIf="(f.name.dirty || f.name.touched || submitted) && f.name.errors">
                  <i> {{f.name.hasError('required') ? 'Quality parameter is required.': f.name.hasError('minlength')? 'Minimum 3 characters required.': f.name.hasError('maxlength')
                    ? 'Maximum 20 characters allowed.' : f.name.hasError('pattern') ? 'Only alphabets allowed.': ''}}</i>
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Abbreviation</mat-label>
                <input matInput id="unitCode" type="text" autocomplete="off" formControlName="abbreviation" placeholder="Enter code"/>
                <mat-hint><i>10 alphanumeric characters</i></mat-hint>
                <mat-error *ngIf="(f.abbreviation.touched || f.abbreviation.dirty || submitted) && f.abbreviation.errors">
                  <i>{{ f.abbreviation.hasError('required') ? 'Abbreviation is required.' : f.abbreviation.hasError('maxlength')? 'Maximum 10 characters allowed.': f.abbreviation.hasError('pattern')? 'Special characters are not allowed.': ''}}</i>
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Units of Measurement</mat-label>
                <input matInput id="uom" type="text" autocomplete="off" formControlName="uom" placeholder="Enter UOM"/>
                <mat-hint><i>10 alphanumeric characters</i></mat-hint>
                <mat-error *ngIf="(f.uom.touched || f.uom.dirty || submitted) && f.uom.errors">
                  <i> {{ f.uom.hasError('required') ? 'UOM is required.' : f.uom.hasError('maxlength') ? 'Maximum 10 characters allowed.' : '' }} </i>
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Unit Code</mat-label>
                <input matInput id="unitcode" type="text" autocomplete="off" formControlName="unit_code" placeholder="Enter unit code"/>
                <mat-hint><i>3-10 alphanumeric characters</i></mat-hint>
                <mat-error *ngIf="(f.unit_code.touched || f.unit_code.dirty || submitted) && f.unit_code.errors">
                  <i> {{ f.unit_code.hasError('required') ? 'Unit code is required.' : f.unit_code.hasError('minlength') ? 'Minimum 3 characters required.' : f.unit_code.hasError('maxlength')? 'Maximum 10 characters allowed.': ''}}</i>
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Quality Parameter Type</mat-label>
                <mat-select id="qpType" formControlName="qp_type_id">
                  <mat-option value="" disabled>Select Quality Parameter Type</mat-option>
                  <mat-option *ngFor="let category of qpTypes" [value]="category.id"> {{ category.name }} </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.qp_type_id .invalid"><i>Select QP Type</i></mat-hint>
                <mat-hint *ngIf="f.qp_type_id .valid"><i>QP type selected</i></mat-hint>
                <mat-error *ngIf="(f.qp_type_id .touched || f.qp_type_id .dirty || submitted) && f.qp_type_id .hasError('required')">
                  <i>Required.</i>
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Test Category</mat-label>
                <mat-select id="tc" formControlName="test_category_id">
                  <mat-option value="" disabled>Select Test Category</mat-option>
                  <mat-option *ngFor="let category of testCategories" [value]="category.id"> {{ category.name }} </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.test_category_id.invalid"><i>Select Test Categories</i></mat-hint>
                <mat-hint *ngIf="f.test_category_id.valid"><i>Test Categories selected</i></mat-hint>
                <mat-error *ngIf="(f.test_category_id.touched || f.test_category_id.dirty || submitted) && f.test_category_id.hasError('required')">
                  <i>Required.</i>
                </mat-error>
              </mat-form-field>
              <mat-checkbox formControlName="is_derived">
                Is Derived
              </mat-checkbox>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Description</mat-label>
                <textarea matInput id="activityDescription" rows="3" formControlName="description" autocomplete="off" placeholder="Description"></textarea>
                <mat-hint><i>Up to 200 characters</i></mat-hint>
                <mat-error *ngIf="(f.description.touched || f.description.dirty || submitted) && f.description.errors">
                  <i> {{ f.description.hasError('required') ? 'Description is required.' : f.description.hasError('maxlength') ? 'Maximum 200 characters allowed.' : '' }} </i>
                </mat-error>
              </mat-form-field>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--add/update form end-->
  </div>
</div>
